import React, { useEffect } from 'react';
import { MapPin, MessagesSquare, Calendar1 } from 'lucide-react';
import { Link } from 'react-router-dom';
import './styles/DraftLeague.css';
import basketballImg from './assets/basketball.png'; // Add this import

const Home = () => {
  // Add this useEffect to set the CSS variable
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--basketball-image',
      `url(${basketballImg})`
    );
  }, []);

  return (
    <div className="draft-league-container">
      {/* Hero Section */}
      <div className="hero">
        {/* Background */}
        <div className="hero-background" />
        <div className="hero-overlay" />

        {/* Floating elements */}
        <div className="floating-element-1" />
        <div className="floating-element-2" />
        <div className="floating-element-3" />

        {/* Main Content */}
        <div className="hero-content">
          <h1 className="hero-title">
            <div className="intro-title-bold">Boys to Men NorCal Presents:</div>
            Grass Valley
            <br />
            <span className="hero-title-bold">Draft League</span>
          </h1>

          {/* Info Cards */}
          <div className="cards-container">
            <a
              href="https://pci.jotform.com/form/262017884531155"
              className="card-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="card">
                <MapPin className="card-icon" size={32} />
                <h3 className="card-title" style={{ textDecoration: "line-through" }}>
                  Register for Season 7
                </h3>
                <p className="card-text" style={{ fontWeight: 700 }}>FULL</p>
                <p className="card-text">August 9, 2026</p>
              </div>
            </a>

            <a
              href="https://chat.whatsapp.com/G92Uk8vxY4x6qQTEWIFpE2"
              className="card-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="card">
                <MessagesSquare className="card-icon" size={32} />
                <h3 className="card-title">Join us on Whatsapp</h3>
                <p className="card-text">Stay up to date</p>
              </div>
            </a>
            <Link to="/schedule" className="card-link">
              <div className="card">
                <Calendar1 className="card-icon" size={32} />
                <h3 className="card-title">Schedule</h3>
                <p className="card-text">Game Dates & Location</p>
              </div>
            </Link>
          </div>

          {/* Call to Action */}
          <a
            href="https://pci.jotform.com/form/262017884531155"
            className="cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Register for Season 7
          </a>

          {/* Links Section */}
          <div className="links-section">
            <div className="links-container">
              <Link to="/about" className="nav-link">
                About
              </Link>
              <a
                href="https://pci.jotform.com/form/262017884531155"
                className="nav-link"
              >
                Registration
              </a>
              <Link to="/rules" className="nav-link">
                Rules
              </Link>
              <Link to="/schedule" className="nav-link">
                Schedule
              </Link>
              <a
                href="https://www.youtube.com/@GVDraftLeague"
                className="nav-link"
              >
                Youtube
              </a>
              <a
                href="https://hoopsalytics.com/stats/leaderboard.php?program_id=583&embed=1&token=67b1a5bdd561332fd1af0de2d8a2f6cc"
                className="nav-link"
              >
                Stats
              </a>
              <Link to="/100hoop" className="nav-link">
                100 Hoop Challenge
              </Link>
              <a href="https://www.boystomennorcal.org" className="nav-link">
                Boys to Men NorCal
              </a>
              <a href="mailto:matt@boystomennorcal.org" className="nav-link">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <div className="footer-content">
          <p className="footer-text">
            &copy; 2026 Boys to Men NorCal. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
